<template>
	<div class="question-list ">
		<div class="Q-content" :style="{ 'margin-left': marginLeft + 'px' }">
			<p class="top-title">{{ info.questionnaireText }}</p>
			<div class="num-right">
				<p v-if="radio1 == '按指标填写'" class="num">答题：{{ finishNum1 }}/{{ allNum1 }}</p>
				<p v-else class="num">答题：{{ finishNum2 }}/{{ allNum2 }}</p>
				<div class="right-tab">
					<el-radio-group @input="radio1Chage" v-model="radio1">
						<el-radio-button label="按指标填写"></el-radio-button>
						<el-radio-button label="按部门填写"></el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<div v-if="radio1 == '按指标填写'">
				<IndexQuestions :questionsList="defaultQuestion" :infoId="info.id" @dataUpdated="getDefaultQuestion"
					@distribution="Distribution" @allCheck1="allCheck1" />
			</div>
			<div v-else>
				<DeparentmentQuestions :questionsList="userDefinedQuestion" :infoId="info.id"
					@dataUpdated="getUserDefinedQuestion" @allCheck2="allCheck2"
					@distribution="Distribution" />
			</div>
		</div>
		<span v-loading.fullscreen.lock="fullscreenLoading"></span>

	</div>
</template>

<script>
import Cookies from 'js-cookie';
import {
	viewQuestionApi
} from '../../api/api-url/viewQuestion.js'
import DeparentmentQuestions from './departmentQuestions.vue'
import IndexQuestions from './indexQuestions.vue'
import store from '../../store';
export default {
	name: 'QuestionList',
	components: {
		DeparentmentQuestions,
		IndexQuestions
	},
	data() {
		return {
			fullscreenLoading: false,
			user: {},
			info: {},
			radio1: '按指标填写',
			marginLeft: 0,
			tableData: [],
			defaultQuestion: [],//按指标分类
			allNum1: 0,
			finishNum1: 0,
			allNum2: 0,
			finishNum2: 0,
			// 分配部门相关数据
			DepartmentData: {
				list: [],//部门列表
				arr: [],//待分配部门的问题
				visible: false,//分配部门弹窗
				newName: '',//新建部门的名字
				updateId: '',//要修改的部门的id
				updataVisible: false,//修改部门名称的弹窗
				updateName: '',//修改部门时候的新名字
				chooseName: '',//选择部门的id
			},
			userDefinedQuestion: [],//按部门分类
			qusType: '',
			dimensionName: ''
		}
	},
	created() {
		// console.log(window.screen.width)
	},
	mounted() {
		this.marginLeft = (window.screen.width - 1000) / 2;
		this.getUserDefinedQuestion()
		this.getDefaultQuestion()
		this.getUserInfo()
		if (store.state.radio === 2) {
			this.radio1 = '按部门填写'
		}
	},
	methods: {
		// 获取用户信息和问卷信息
		async getUserInfo() {
			let res = await viewQuestionApi.selectUserInfo({
				companyId: window.sessionStorage.getItem('companyId')
			})
			console.log(res)
			if (res.code == 1) {
				Cookies.set('companyName', res.result.user.companyName, {
					expires: 30
				})
				if (res.result.info != null) {
					this.info = res.result.info;
				}
				this.user = res.result.user;
			}
		},
		// 获取默认分类问卷信息（维度分类）
		async getDefaultQuestion() {
			this.fullscreenLoading = true
			let res = await viewQuestionApi.selectDefaultQuestion({
				companyId: window.sessionStorage.getItem('companyId')
			})
			if (res) {
				// console.log(res);
				this.allNum1 = res.result.total;
				this.finishNum1 = res.result.progress;
				const value = res.result.defaultList.map(item => {
					item.value = item.value.map(ite => {
						ite.checkList = [];
						ite.allChecked = false;
						return ite
					})
					return item
				});
				this.defaultQuestion = value
				// console.log(this.defaultQuestion);
				this.fullscreenLoading = false
			}
		},
		// 获取默认分类问卷信息（自定义分类）
		async getUserDefinedQuestion() {
			let res = await viewQuestionApi.selectUserDefinedQuestion({
				companyId: window.sessionStorage.getItem('companyId')
			})
			// console.log(res)
			if (res) {
				this.allNum2 = res.result.total;
				this.finishNum2 = res.result.progress;
				this.userDefinedQuestion = res.result.userDefinedList.map(item => {
					item.checkList = [];
					item.allChecked = false;
					return item
				});
			}
		},
		// 切换按指标还是按部门展示
		radio1Chage(val) {
			if (val == '按指标填写') {
				store.commit('setRadio', 1)
				this.getDefaultQuestion()
			} else {
				store.commit('setRadio', 2)
				this.getUserDefinedQuestion()
			}
		},

		// 分配全选（维度分类）
		allCheck1(val, index, ind) {
			if (val) {
				this.defaultQuestion[index].value[ind].checkList = this.defaultQuestion[index].value[ind].value.map(item => {
					if (item.submitStatus == 0) {
						return item.id
					}
				})
			} else {
				this.defaultQuestion[index].value[ind].checkList = [];
			}
		},
		// 分配全选（自定义分类）
		allCheck2(val, index) {
			console.log(val, index);

			if (val) {
				this.userDefinedQuestion[index].checkList = this.userDefinedQuestion[index].value.map(item => {
					console.log(item.submitStatus);
					if (item.submitStatus == 0) {
						return item.id
					}
				})
			} else {
				this.userDefinedQuestion[index].checkList = [];
			}
		},
		//打开分配问题页面
		Distribution(arr) {
			this.getClassify();
			this.DepartmentData.arr = arr;
			this.DepartmentData.newName = '';
			this.DepartmentData.visible = true;
		},
		
		async submitQuestionnaire() {
			const res = await viewQuestionApi.selectSubmitQuestionnaire({
				id: this.info.id
			})
			if (res) {
				console.log(res);
			}
		},
		
	},
}
</script>

<style scoped lang="scss">
.question-list {
	padding-top: 20px;
	background-color: #fff;
	height: 100%;
	overflow-y: auto;

	.Q-content {
		width: 1000px;
		padding-bottom: 76px;

		.top-title {
			text-align: center;
			font-size: 24px;
			color: #333333;
			font-weight: 700;
			margin-top: 30px;
			margin-bottom: 20px;
		}

		.num-right {
			position: relative;

			.num {
				line-height: 38px;
			}

			.right-tab {
				position: absolute;
				right: 0px;
				top: 5px;
			}
		}

		.top-btn {
			width: 150px;
			height: 48px;
			margin-top: 31px;
			margin-bottom: 5px;
		}

		.submit-btn {
			display: block;
			margin: 0 auto;
			width: 280px;
			height: 48px;
			background: #3B9395;
			border-radius: 2px;
			color: #fff;
		}

	}

	.dialog-input {
		position: relative;

		.d-i-btn {
			position: absolute;
			right: 0px;
			top: 0px;
		}
	}

	.d-c-title {
		font-size: 14px;
		color: #333;
		line-height: 44px;
	}

	.d-c-noList {
		color: #979797;
	}

	.d-c-ul {
		.d-c-u-item {
			height: 32px;
			position: relative;
			background-color: #fff;

			.el-radio {
				margin-top: 8px;
				margin-left: 10px;
			}

			.d-c-u-i-update {
				color: #3B9395;
				border-bottom: 1px solid #3B9395;
				cursor: pointer;
				margin-left: 10px;
			}

			.d-c-u-i-delete {
				color: #FF3B3B;
				border-bottom: 1px solid #FF3B3B;
				cursor: pointer;
				margin-left: 10px;
			}
		}
	}
}
</style>